import { useLocation, useNavigate } from 'react-router-dom';
import {
  TERMINAL_VIEWPORT_DEBUG_QUERY_PARAM,
  terminalViewportDebugRequested
} from './TerminalViewportDebug';

export function terminalDebugSearch(search: string, enabled: boolean): string {
  const params = new URLSearchParams(search);
  params.delete('terminalDebug');
  params.delete(TERMINAL_VIEWPORT_DEBUG_QUERY_PARAM);
  if (enabled) params.set(TERMINAL_VIEWPORT_DEBUG_QUERY_PARAM, '1');
  return params.toString();
}

/** Discoverability only: existing diagnostics are local geometry, not privileged server data. */
export default function TerminalDebugToggle({ isAdmin }: { isAdmin: boolean }) {
  const location = useLocation();
  const navigate = useNavigate();
  if (!isAdmin) return null;
  const enabled = terminalViewportDebugRequested(location.search);
  return (
    <button
      type="button"
      className="secondary"
      aria-label="Terminal debug"
      aria-pressed={enabled}
      title="Enable local viewport diagnostics. In full screen, Debug pastes a report without sending Enter."
      onClick={() => navigate({
        pathname: location.pathname,
        search: terminalDebugSearch(location.search, !enabled),
        hash: location.hash
      }, { replace: true, preventScrollReset: true })}
    >
      Debug {enabled ? 'on' : 'off'}
    </button>
  );
}
